// Browser variant of `./navigation-dynamic-rendering`. The dynamic-rendering
// hooks only run on the server; callers use optional calls, so these are
// `undefined` in the browser.
export const useDynamicRouteParams = undefined
export const useDynamicSearchParams = undefined
